import { PageSerializersBooksLayout } from "types/serializers";
import useCurrentUser from "hooks/fragments/useCurrentUser";
import Icon from "hardcover-ui/components/Icon";
import faClone from "icons/regular/clone.svg";
import faBug from "icons/regular/bug.svg";
import faPencil from "icons/solid/pencil.svg";
import DrawerButton from "components/ui/DrawerButton";
import DrawerDivider from "components/ui/DrawerDivider";
import ReportButton from "../Report/ReportButton";

export default function ReportBookMenu({
  book,
  onDuplicate,
  onClose,
}: {
  book: PageSerializersBooksLayout;
  onDuplicate: () => void;
  onClose: () => void;
}) {
  const admin = useCurrentUser((u) => u.admin);

  return (
    <div className="md:flex md:flex-col md:items-start">
      <DrawerButton onClick={onDuplicate}>
        <Icon
          icon={faClone}
          size="md"
        />
        <span>Flag as duplicate</span>
      </DrawerButton>

      <DrawerDivider />

      <DrawerButton
        className="p-2"
        as={{
          element: "link",
          props: {
            href: `/books/${book.id}/edit`,
          },
      }}>
        <Icon
          icon={faPencil}
          size="md"
        />
        <span>Edit this book</span>
      </DrawerButton>

      <DrawerDivider />

      {admin && (
        <>
          <DrawerButton
            className="p-2"
            as={{
              element: "link",
              props: {
                target: "_blank",
                rel: "noreferrer",
                href: `/admin/books/${book.slug}`,
              },
          }}>
            <Icon icon={faPencil} size="md" />
            <span>Edit in admin</span>
          </DrawerButton>
          <DrawerDivider />
        </>
      )}

      <ReportButton
        className="p-2 text-lg md:text-base px-4 py-2 lg:py-1 w-full font-semibold space-x-1 text-gray-900 dark:text-white group hover:bg-gray-200 dark:hover:bg-gray-700 hover:text-indigo-700 dark:hover:text-yellow-400 transition-all"
        objectId={book.id}
        objectType="Book"
        description={`Book: '${book.title}'`}
        close={onClose}
      >
        <Icon icon={faBug} size="md" />
        <span>Report a problem</span>
      </ReportButton>
    </div>
  );
}
